import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, MenuItem, Menu, 
  // IconButton, Checkbox 
} from "@mui/material";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate, useParams } from "react-router-dom";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { PiCopyFill } from "react-icons/pi";
import { FaClone } from "react-icons/fa6";
import { fetchEntityById } from "../../../apis/apiService";
// import { CustomNoRowsOverlay } from "../../projects/Project";
import Loader from "../../../components/common/Loader";
import { CustomNoRowsOverlay } from "../../../components/common/OverlayGrid";



const UserMilestone = () => {
  const { id } = useParams();
  const [paginationModel, setPaginationModal] = useState({
    page: 0,
    pageSize: 10,
  });
  const [loading, setLoading] = useState(false);
  const columns = [
    // {
    //   field: "actions",
    //   headerName: "Action",
    //   width: 120,
    //   renderCell: (params) => (
    //     <Box display="flex" alignItems="center">
    //       {/* More options button */}
    //       <IconButton
    //         onClick={(event) => {
    //           event.stopPropagation(); // Prevent row click event
    //           handleMenuOpen(event, params.row.id); // Example menu functionality
    //         }}
    //       >
    //         <MoreVertIcon />
    //       </IconButton>
    //       {/* check box button */}
    //       <IconButton
    //         onClick={(event) => {
    //           event.stopPropagation(); // Prevent row click event
    //         }}
    //       >
    //         <Checkbox />
    //       </IconButton>
    //     </Box>
    //   ),
    // },
    {
      field: "milestone_title",
      headerName: "Milestones Name",

      width: 200,
    },
    {
      field: "completed_percentage",
      headerName: "Completed %",
      width: 120,
      // valueGetter: (params) => `${params.row.completed_percentage}%`,
    },
    {
      field: "added_by",
      headerName: "Owner",
      width: 150,
    },
    {
      field: "milestone_status",
      headerName: "Status",
      width: 180,
      renderCell: (params) => {
        const status = params.value;
        let color;

        // Set color based on status
        switch (status) {
          case "Active":
            color = "rgba(0, 191, 0, 1)";
            break;
          case "In Progress":
            color = "blue";
            break;
          case "Not Started":
            color = "red";
            break;
          case "Completed":
            color = "Green";
            break;
          default:
            color = "black";
        }

        return (
          <Box
            sx={{
              color: color,
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {status}
          </Box>
        );
      },
    },
    {
      field: "start_date",
      headerName: "Start Date",
      width: 150,
    },
    {
      field: "end_date",
      headerName: "End Date",
      width: 150,
    },
    {
      field: "Task",
      headerName: "Task",
      width: 150,
    },
    {
      field: "Issues",
      headerName: "Issues",
      width: 150,
    },
  ];

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [Milestone, setMilestone] = useState([]);
  const navigate = useNavigate();
  const fetchMilestone = async () => {
    setLoading(true);
    try {
      const response = await fetchEntityById("getMilestoneDetails", id);
      const userMIlestone = Array.isArray(response.data)
        ? response.data.flatMap((item) => item.milestones || [])
        : [];

      setMilestone(userMIlestone);
    } 
    catch (error) {
      console.error("Error fetching issues:", error);
    } 
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchMilestone();
  }, [id]);

  const handleMenuOpen = (event, taskId) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    setSelectedTask(taskId);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null);
  };

  const handleClone = () => {
    // //console.log()(`Clone task: ${selectedTask}`);
    handleMenuClose();
  };

  const handleView = () => {
    // //console.log()(`View task: ${selectedTask}`);
    handleMenuClose();
  };
  const handleViewDitailstab = () => {
    // //console.log()(`View task on new tab: ${selectedTask}`);
    handleMenuClose();
  };
  const handleCopylink = () => {
    // //console.log()(`Copy task: ${selectedTask}`);
    handleMenuClose();
  };

  // Handle row click
  const handleRowClick = (params) => {
    const { milestone_id } = params.row;
    navigate(`/projects/projectDetail/milestone/MilestoneDetail/${milestone_id}`);
  };

  return (
    <>
      <div className="py-3">
        <Box style={{ width: "100%" }}>
          {loading ? (
            <Loader />
          ) : (
            <Box sx={{ height: Milestone.length === 0 ? 300 : "100%" }}>
              <DataGrid
                rows={Milestone}
                columns={columns}
                pagination
                onPaginationModelChange={setPaginationModal}
                paginationModel={paginationModel}
                pageSizeOptions={[10, 20, 30, 40]}
                slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                // onRowClick={handleRowClick}
                getRowId={(row) => row.milestone_id}
                // hideFooter
                disableSelectionOnClick
              />
            </Box>
          )}

          {/* Menu for Action Button Options */}
          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleView}>
              <CiViewList className="me-2" />
              View Details
            </MenuItem>
            <MenuItem onClick={handleViewDitailstab}>
              <MdViewQuilt className="me-2" />
              View Details in New Tab
            </MenuItem>
            <MenuItem onClick={handleCopylink}>
              <PiCopyFill className="me-2" />
              Copy Link
            </MenuItem>
            <MenuItem onClick={handleClone}>
              <FaClone className="me-2" />
              Clone
            </MenuItem>
          </Menu>
        </Box>
      </div>
    </>
  );
};

export default UserMilestone;
